// The approved design's icon set: 24-grid stroke paths (copied from the
// console prototype so every icon matches it).
const IP = {
  home:'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  grid:'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  map:'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2zM9 4v14M15 6v14',
  list:'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  house:'M4 11 12 4l8 7M6 9.5V20h12V9.5M10 20v-5h4v5',
  chip:'M7 7h10v10H7zM10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4',
  users:'M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-5A3.5 3.5 0 0 0 4 18.5V20M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M20 20v-1.5a3.5 3.5 0 0 0-2.5-3.35M15.5 4.15a3.5 3.5 0 0 1 0 6.7',
  wallet:'M4 7a2 2 0 0 1 2-2h12v4M4 7v11a2 2 0 0 0 2 2h14V9H6a2 2 0 0 1-2-2zM16.5 14.5h.01',
  search:'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4',
  bell:'M6 9a6 6 0 1 1 12 0c0 6 2.5 7.5 2.5 7.5h-17S6 15 6 9zM10 20a2 2 0 0 0 4 0',
  sun:'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon:'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  auto:'M12 3a9 9 0 1 0 0 18zM12 3a9 9 0 0 1 0 18',
  x:'M6 6l12 12M18 6 6 18',
  chev:'M9 6l6 6-6 6',
  chevd:'M6 9l6 6 6-6',
  plus:'M12 5v14M5 12h14',
  minus:'M5 12h14',
  target:'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM12 2v3M12 19v3M2 12h3M19 12h3',
  phone:'M5 4h3.5l1.5 4.5-2 1.5a11 11 0 0 0 6 6l1.5-2 4.5 1.5V19a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z',
  msg:'M4 5h16v11H8l-4 4z',
  send:'M4 12 20 4l-6 16-3-7z',
  arrow:'M5 12h14M13 6l6 6-6 6',
  up:'M12 19V5M6 11l6-6 6 6',
  check:'M5 12.5l4.5 4.5L19 7.5',
  alert:'M12 3 2.5 20h19zM12 10v4.5M12 17.5h.01',
  clock:'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  moto:'M6 17a3 3 0 1 0 0-.01M18 17a3 3 0 1 0 0-.01M6 17l3-6h4l2 3h3M9 11 8 8H6',
  pin:'M12 21s-7-7.6-7-12a7 7 0 0 1 14 0c0 4.4-7 12-7 12zM12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5',
  box:'M3 7.5 12 3l9 4.5v9L12 21l-9-4.5zM3 7.5l9 4.5 9-4.5M12 12v9',
  cyl:'M8 7h8v2.5a4 4 0 0 1 2 3.5V19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6a4 4 0 0 1 2-3.5zM10 3h4v4h-4z',
  wifi:'M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M12 19.5h.01M2 9a14.5 14.5 0 0 1 20 0',
  battery:'M3 8h15v8H3zM21 11v2',
  card:'M3 6h18v12H3zM3 10h18M7 15h3',
  tool:'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
  doc:'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6',
  star:'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  route:'M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM6 15V9a4 4 0 0 1 4-4h2M18 9v6a4 4 0 0 1-4 4h-2',
  download:'M12 4v11M7 10l5 5 5-5M5 20h14',
  filter:'M4 5h16l-6 7.5V19l-4 2v-8.5z',
  layers:'M12 3 2 8l10 5 10-5zM2 13l10 5 10-5',
  play:'M7 5v14l11-7z',
  pause:'M8 5v14M16 5v14',
  bolt:'M13 2 4 14h7l-1 8 9-12h-7z',
  store:'M4 9h16l-1-5H5zM5 9v11h14V9M9 20v-6h6v6',
  undo:'M9 14 4 9l5-5M4 9h11a5 5 0 0 1 0 10h-3',
  refresh:'M20 12a8 8 0 1 1-2.34-5.66L20 8.5M20 3.5v5h-5',
  eye:'M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  lock:'M6 11h12v9.5H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  pkg:'M12 3 3 7.5 12 12l9-4.5zM3 7.5v9L12 21v-9M21 7.5v9L12 21',
  hand:'M8 13V5.5a1.5 1.5 0 0 1 3 0V11M11 11V4.5a1.5 1.5 0 0 1 3 0V11M14 11V6a1.5 1.5 0 0 1 3 0v8a7 7 0 0 1-7 7h-.5A6.5 6.5 0 0 1 4 16.5L3 13a1.5 1.5 0 0 1 2.6-1.4L8 14',
} as const;

export type IconName = keyof typeof IP;

export function Ic({ n, s = '' }: { n: IconName; s?: '' | 's' | 'xs' }) {
  return (
    <svg className={'i ' + s} viewBox="0 0 24 24" aria-hidden="true">
      <path d={IP[n]} />
    </svg>
  );
}

let flameId = 0;
/** Gazelle's mark: the white flame on the warm disc. */
export function Flame() {
  const id = 'fl' + ++flameId;
  return (
    <svg className="flame" viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#FF4D4D" /><stop offset=".55" stopColor="#FF7A3D" /><stop offset="1" stopColor="#FFB547" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="12" fill={`url(#${id})`} />
      <path d="M12.4 5.5c.3 2.2 2.9 3.4 2.9 6.5a3.4 3.4 0 0 1-6.8 0c0-1.3.6-2.3 1.3-3 .1 1 .6 1.7 1.4 2 0-2.3.4-4.1 1.2-5.5z" fill="#fff" />
    </svg>
  );
}
